import React, { useState, useEffect, useContext } from "react";
import CartItem from "./CartItem";
import "./Cart.css";
import { Pagination } from "react-bootstrap";
import ConfigContext from "../../context/config/ConfigContext";

const CartList = ({ cart, enableAction, onDelete, onEdit }) => {
  const configContext = useContext(ConfigContext);
  const { getConfigValue } = configContext;
  //  const { card, labels } = props;
  console.log("Cart Items:", JSON.stringify(cart));
  console.log("Cart Items:", JSON.stringify(cart.cartItems));
  const [itemsInPage, setItemsInPage] = useState([]);
  const [active, setActive] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(1);

  useEffect(() => {
    async function asyncEffect() {
      const itemPerPage = await getConfigValue(
        "generalConfig",
        "page_size",
        "App_Config"
      );
      console.log("MAP", itemPerPage);
      setItemsPerPage(itemPerPage);
    }
    asyncEffect();
    //eslint-disable-next-line
  }, []);

  const pages = Math.ceil(cart.cartItems.length / itemsPerPage);

  useEffect(() => {
    changePage(1);
    //eslint-disable-next-line
  }, [cart.cartItems]);

  useEffect(() => {
    changePage(1);
    //eslint-disable-next-line
  }, [itemsPerPage]);

  let items = [];
  for (let number = 1; number <= pages; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === active}
        onClick={() => changePage(number)}
      >
        {number}
      </Pagination.Item>
    );
  }

  const changePage = (pageNo) => {
    setItemsInPage([]);
    setActive(pageNo);
    let prevPage = pageNo - 1;
    if (cart && cart.cartItems) {
      cart.cartItems.forEach((item, index) => {
        for (let i = prevPage * itemsPerPage; i < pageNo * itemsPerPage; i++) {
          console.log();
          if (index === i) {
            console.log("map item", item);
            setItemsInPage((itemsInPage) => [...itemsInPage, item]);
          }
        }
      });
    }
  };

  const onPrev = () => {
    if (active !== 1) {
      changePage(active - 1);
    }
  };

  const onNext = () => {
    if (active !== pages) {
      changePage(active + 1);
    }
  };

  return (
    <div className="cartList">
      <tr className="cartList__title">
        <th>ITEMS</th>
        <th>PRICE</th>
      </tr>
      {itemsPerPage !== 0 &&
        itemsInPage &&
        itemsInPage.map((item) => (
          <div key={item.itemId} className="cartList__items" role="row">
            <CartItem
              item={item}
              enableAction={enableAction}
              onDeleteCartItem={onDelete}
              onEditCartItem={onEdit}
            />
          </div>
        ))}
      {pages !== 1 && (
        <Pagination size="sm" role="navigation" aria-label="pagination">
          <Pagination.Prev onClick={onPrev} />
          {items}
          <Pagination.Next onClick={onNext} />
        </Pagination>
      )}
      <div className="cartList__total">
        <div>SUBTOTAL:</div>
        {cart && <div>${(cart.price / 100).toFixed(2)}</div>}
      </div>
    </div>
  );
};

export default CartList;
